// Type definition for our environment variables
interface EnvConfig {
  // API
  NEXT_PUBLIC_API_HOST?: string;
  NEXT_PUBLIC_API_VERSION?: string;
  API_SECRET_KEY?: string;

  // Web Domain
  NEXT_PUBLIC_DOMAIN?: string;
  NEXT_PUBLIC_BASE_URL?: string;
  NEXT_PUBLIC_SITE_NAME?: string;

  // Image Configuration
  NEXT_PUBLIC_IMAGE_DOMAIN?: string;
  NEXT_PUBLIC_CLOUDINARY_CLOUD_NAME?: string;
  NEXT_PUBLIC_CLOUDINARY_API_KEY?: string;

  // Other configurations
  [key: string]: string | undefined;
}

// Get environment variables with fallbacks
const getEnvConfig = (): EnvConfig => {
  // Default values
  const defaults: EnvConfig = {
    NEXT_PUBLIC_API_HOST: "https://dev.id.oten.tech",
    NEXT_PUBLIC_API_VERSION: "v1",
    NEXT_PUBLIC_DOMAIN: "localhost:3000",
    NEXT_PUBLIC_BASE_URL: "http://localhost:3000",
    NEXT_PUBLIC_SITE_NAME: "My Next.js App",
    NEXT_PUBLIC_IMAGE_DOMAIN: "localhost:3000",
  };

  // Return process.env with defaults
  return {
    ...defaults,
    ...process.env,
  };
};

// Export the environment configuration
export const envConfig = getEnvConfig();

// Helper function to get a specific environment variable
export const getEnv = (key: keyof EnvConfig, defaultValue?: string): string => {
  return envConfig[key] || defaultValue || "";
};

// Helper to check if we're in development mode
export const isDevelopment = process.env.NODE_ENV === "development";

// Helper to check if we're in production mode
export const isProduction = process.env.NODE_ENV === "production";

export default envConfig;
